/**
 * Shared relationship options used across the Add Contact flow.
 *
 * All dropdowns and CSV-validation arrays should reference this constant
 * so that adding or reordering options only requires a single change.
 */
export const RELATIONSHIP_OPTIONS = [
  'Spouse',
  'Partner',
  'Parent',
  'Child',
  'Sibling',
  'Grandparent',
  'Grandchild',
  'Friend',
  'Colleague',
  'Attorney',
  'Accountant',
  'Executor',
  'Trustee',
  'Beneficiary',
  'Other',
] as const;

export type RelationshipOption = (typeof RELATIONSHIP_OPTIONS)[number];

export const isValidRelationship = (value: string): boolean =>
  RELATIONSHIP_OPTIONS.map(r => r.toLowerCase()).includes(value.toLowerCase());
